export const CATEGORY_OPTIONS = [
  { value: 'GASTRONOMÍA', label: 'Gastronomía' },
  { value: 'VIAJES', label: 'Viajes' },
  { value: 'SUPERMERCADOS', label: 'Supermercados' },
  { value: 'PINTURERÍAS', label: 'Pinturerías' },
  { value: 'INDUMENTARIA', label: 'Indumentaria' },
  { value: 'SALUD Y BELLEZA', label: 'Salud y Belleza' },
  { value: 'FARMACIAS', label: 'Farmacias' },
  { value: 'LIBRERÍAS', label: 'Librerías' },
  { value: 'ELECTRO Y TECNOLOGÍA', label: 'Electro y Tecnología' },
  { value: 'AUTOMOTOR', label: 'Automotor' },
  { value: 'TRANSPORTE', label: 'Transporte' },
  { value: 'ESPECTÁCULOS', label: 'Espectáculos' },
  { value: 'MASCOTAS', label: 'Mascotas' }
];
